export default __webpack_public_path__ + "static/media/KlipVidThree.3cf20c64.png";